import { Component, OnInit } from '@angular/core';
import { Evenement } from '../../models/evenement.model';
import { EvenementService } from '../../services/evenement.service';
import { JournalService } from '../../services/journal.service';

@Component({
  selector: 'app-gestion-evenements',
  templateUrl: './gestion-evenements.component.html',
  styleUrls: ['./gestion-evenements.component.css']
})
export class GestionEvenementsComponent implements OnInit {

  evenements: Evenement[] = [];
  formEvenement: Evenement = this.formVide();
  idEnModification: number | null = null;
  messageConfirmation = '';

  // Recherche et filtre
  texteRecherche = '';
  filtreCategorie = '';

  constructor(
    private evenementService: EvenementService,
    private journalService: JournalService
  ) { }

  ngOnInit(): void {
    this.chargerEvenements();
  }

  chargerEvenements(): void {
    this.evenementService.getEvenements().subscribe(data => {
      this.evenements = data;
    });
  }

  // Liste filtree affichee dans le tableau (recherche + categorie)
  get evenementsFiltres(): Evenement[] {
    return this.evenements.filter(ev => {
      const correspondTexte = ev.titre.toLowerCase().includes(this.texteRecherche.toLowerCase());
      const correspondCategorie = !this.filtreCategorie || ev.categorie === this.filtreCategorie;
      return correspondTexte && correspondCategorie;
    });
  }

  formVide(): Evenement {
    return {
      titre: '', titreEn: '', titreAr: '',
      description: '', descriptionEn: '', descriptionAr: '',
      categorie: 'Musique', lieu: '', dateEvent: '', prix: 0, imageUrl: '', youtubeId: ''
    };
  }

  validerFormulaire(): void {
    if (this.idEnModification !== null) {
      this.evenementService.updateEvenement(this.idEnModification, this.formEvenement).subscribe(() => {
        this.messageConfirmation = 'Événement modifié avec succès !';
        this.journalService.ajouter(`Événement « ${this.formEvenement.titre} » modifié.`).subscribe();
        this.annulerModification();
        this.chargerEvenements();
        setTimeout(() => this.messageConfirmation = '', 3000);
      });
    } else {
      this.evenementService.createEvenement(this.formEvenement).subscribe(() => {
        this.messageConfirmation = 'Événement ajouté avec succès !';
        this.journalService.ajouter(`Événement « ${this.formEvenement.titre} » ajouté.`).subscribe();
        this.formEvenement = this.formVide();
        this.chargerEvenements();
        setTimeout(() => this.messageConfirmation = '', 3000);
      });
    }
  }

  modifierEvenement(evenement: Evenement): void {
    this.idEnModification = evenement.id !== undefined ? evenement.id : null;
    this.formEvenement = { ...evenement };
  }

  annulerModification(): void {
    this.idEnModification = null;
    this.formEvenement = this.formVide();
  }

  supprimerEvenement(evenement: Evenement): void {
    if (evenement.id === undefined) return;

    if (confirm('Supprimer cet événement ?')) {
      this.evenementService.deleteEvenement(evenement.id).subscribe(() => {
        this.journalService.ajouter(`Événement « ${evenement.titre} » supprimé.`).subscribe();
        this.chargerEvenements();
      });
    }
  }
}
